import { create } from 'zustand';
import { toast } from 'react-toastify';
import axiosToken from '../api/axiosClient';

const useSalonStore = create((set, get) => ({
    // États
    salons: [],
    currentSalon: null,
    isLoadingSalons: false,
    isLoadingSalon: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,

    // Récupérer tous les salons
    getAllSalons: async () => {
        set({ isLoadingSalons: true });
        try {
            const response = await axiosToken.get('/salon/');
            const salonsData = response.data?.data || response.data || [];

            console.log({salonsData})
            set({
                salons: salonsData,
                isLoadingSalons: false
            });

            return salonsData;
        } catch (error) {
            console.error("Erreur getAllSalons :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement des salons.");
            set({ isLoadingSalons: false });
            return [];
        }
    },

    // Récupérer un salon par ID
    getSalonById: async (salonId) => {
        set({ isLoadingSalon: true });
        try {
            const response = await axiosToken.get(`/salon/${salonId}`);
            const salonData = response.data?.data || response.data;

            set({
                currentSalon: salonData,
                isLoadingSalon: false
            });

            return salonData;
        } catch (error) {
            console.error("Erreur getSalonById :", error);
            toast.error(error?.response?.data?.error || "Erreur lors du chargement du salon.");
            set({ isLoadingSalon: false });
            return null;
        }
    },

    // Créer un nouveau salon
    createSalon: async (salonData) => {
        set({ isCreating: true });
        try {
            const data = {
                designation: salonData.designation,
                openingTime: salonData.openingTime,
                closingTime: salonData.closingTime,
                maxDailyBookings: parseInt(salonData.maxDailyBookings),
                maxHourlyBookings: parseInt(salonData.maxHourlyBookings),
                slotDuration: parseInt(salonData.slotDuration),
                closedDays: salonData.closedDays || []
            };

            console.log('📤 Création salon - Données envoyées:', data);

            const response = await axiosToken.post('/salon/', data);
            const newSalon = response.data?.data || response.data;

            // Mettre à jour la liste des salons
            set(state => ({
                salons: [...state.salons, newSalon],
                isCreating: false
            }));

            toast.success('Salon créé avec succès !');
            return newSalon;
        } catch (error) {
            console.error("Erreur createSalon :", error);
            const errorMessage = error?.response?.data?.error || "Erreur lors de la création du salon.";
            toast.error(errorMessage);
            set({ isCreating: false });
            throw error;
        }
    },

    // Mettre à jour un salon
    updateSalon: async (salonId, salonData) => {
        set({ isUpdating: true });
        try {
            const data = {
                designation: salonData.designation,
                openingTime: salonData.openingTime,
                closingTime: salonData.closingTime,
                maxDailyBookings: parseInt(salonData.maxDailyBookings),
                maxHourlyBookings: parseInt(salonData.maxHourlyBookings),
                breakStart: salonData.breakStart,
                breakEnd: salonData.breakEnd,
                slotDuration: parseInt(salonData.slotDuration),
                closedDays: salonData.closedDays || []
            };


            const response = await axiosToken.put(`/salon/${salonId}`, data);
            const updatedSalon = response.data?.data || response.data;

            // Mettre à jour la liste des salons et le salon courant
            set(state => ({
                salons: state.salons.map(salon =>
                    salon.id === salonId ? updatedSalon : salon
                ),
                currentSalon: state.currentSalon?.id === salonId ? updatedSalon : state.currentSalon,
                isUpdating: false
            }));

            toast.success('Salon mis à jour avec succès !');
            return updatedSalon;
        } catch (error) {
            console.error("Erreur updateSalon :", error);
            const errorMessage = error?.response?.data?.error || "Erreur lors de la mise à jour du salon.";
            toast.error(errorMessage);
            set({ isUpdating: false });
            throw error;
        }
    },

    // Supprimer un salon
    deleteSalon: async (salonId) => {
        set({ isDeleting: true });
        try {
            await axiosToken.delete(`/salon/${salonId}`);

            // Mettre à jour la liste des salons
            set(state => ({
                salons: state.salons.filter(salon => salon.id !== salonId),
                currentSalon: state.currentSalon?.id === salonId ? null : state.currentSalon,
                isDeleting: false
            }));

            toast.success('Salon supprimé avec succès !');
            return true;
        } catch (error) {
            console.error("Erreur deleteSalon :", error);
            const errorMessage = error?.response?.data?.error || "Erreur lors de la suppression du salon.";
            toast.error(errorMessage);
            set({ isDeleting: false });
            throw error;
        }
    },

    // Réinitialiser le salon courant
    resetCurrentSalon: () => {
        set({ currentSalon: null });
    },

    // Synchroniser l'ajout d'un salon (pour les updates immédiates)
    syncAddSalon: (newSalon) => {
        set(state => ({
            salons: [...state.salons, newSalon]
        }));
    },

    // Synchroniser la mise à jour d'un salon
    syncUpdateSalon: (updatedSalon) => {
        set(state => ({
            salons: state.salons.map(salon =>
                salon.id === updatedSalon.id ? updatedSalon : salon
            ),
            currentSalon: state.currentSalon?.id === updatedSalon.id ? updatedSalon : state.currentSalon
        }));
    },

    // Synchroniser la suppression d'un salon
    syncDeleteSalon: (salonId) => {
        set(state => ({
            salons: state.salons.filter(salon => salon.id !== salonId),
            currentSalon: state.currentSalon?.id === salonId ? null : state.currentSalon
        }));
    }
}));

export default useSalonStore;